module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-normal.29a0efaa.png";